// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod'

export const zAnalyticsToken = z.object({
  AccessToken: z.string(),
  ExpiresIn: z.union([
    z.number(),
    z.string().regex(/^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$/),
  ]),
})

export const zApplicationConfigurationDto = z.object({
  ApplicationConfigurationId: z.uuid().optional(),
  ApplicationId: z.uuid().optional(),
  OrganizationId: z.string().nullish(),
  UserId: z.string().nullish(),
  InitialExtent: z.string().nullish(),
  Aggregation: z.string().nullish(),
  Basemap: z.string().nullish(),
  Timezone: z.string().nullish(),
  DateFormat: z.string().nullish(),
  TimeFormat: z.string().nullish(),
  HelpdeskUrl: z.string().nullish(),
  Extra: z.string().nullish(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
  Deleted: z.boolean().optional(),
})

export const zApplicationDto = z.object({
  Id: z.uuid().optional(),
  Slug: z.string(),
  Title: z.string().nullish(),
  Description: z.string().nullish(),
  Tag: z.string().nullish(),
  Link: z.string().nullish(),
  Image: z.string(),
  Permission: z.string().nullish(),
  ButtonOnly: z.string().nullish(),
  SortOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zApplyFireriskMetricPresetRequest = z.object({
  IncludePof: z.boolean(),
  IncludePoi: z.boolean(),
  IncludeOutages: z.boolean(),
  DryRun: z.boolean(),
})

export const zAssignedLayerCategoryDto = z.object({
  Id: z.uuid(),
  DisplayName: z.string().nullable(),
})

export const zAssignLayerRequest = z.object({
  LayerIds: z.array(z.uuid()),
  LayerCategoryId: z.uuid().nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
  Zindex: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
})

export const zAuditAction = z.enum(['Insert', 'Update', 'Delete'])

export const zCatalogApplicationDto = z.object({
  Id: z.uuid().optional(),
  DisplayName: z.string().optional(),
})

export const zCatalogLayerDto = z.object({
  Id: z.uuid().optional(),
  Title: z.string().nullish(),
  Description: z.string().nullish(),
  Icon: z.string().nullish(),
  Active: z.boolean().optional(),
  Available: z.boolean().optional(),
  Private: z.boolean().optional(),
  Url: z.string().nullish(),
  LayerTypeName: z.string().nullish(),
  Applications: z.array(z.string()).optional(),
  AssignedCategories: z.array(zAssignedLayerCategoryDto).optional(),
})

export const zCatalogMetricRiskTypeAssignmentDto = z.object({
  RiskType: z.string().nullish(),
  ApplicationId: z.uuid().optional(),
})

export const zCatalogMetricDto = z.object({
  Id: z.uuid().optional(),
  Name: z.string().optional(),
  Displayname: z.string().nullish(),
  Description: z.string().nullish(),
  Icon: z.string().nullish(),
  Uom: z.string().nullish(),
  Datasource: z.string().optional(),
  Active: z.boolean().nullish(),
  CategoryName: z.string().nullish(),
  CategoryId: z.uuid().nullish(),
  MinLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MaxLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  ApplicationId: z.uuid().nullish(),
  Applications: z.array(z.string()).optional(),
  RiskTypes: z.array(zCatalogMetricRiskTypeAssignmentDto).optional(),
})

export const zClientResourceDto = z.object({
  Id: z.uuid().optional(),
  CustomerId: z.uuid().optional(),
  ResourceType: z.string().optional(),
  AccountName: z.string().optional(),
  ResourceName: z.string().optional(),
  Metadata: z.string().nullish(),
})

export const zCreateCustomLayerRequest = z.object({
  Url: z.string(),
  Title: z.string().nullable(),
  LayerType: z.string().nullish(),
  Username: z.string().nullish(),
  Password: z.string().nullish(),
  Token: z.string().nullish(),
})

export const zCreateOrganizationMetricBulkItem = z.object({
  MetricId: z.uuid(),
  DisplayOrder: z.union([
    z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    z.string().regex(/^-?(?:0|[1-9]\d*)$/),
  ]),
})

export const zCreateOrganizationMetricsBulkRequest = z.object({
  ApplicationId: z.uuid(),
  RiskType: z.string().nullable(),
  MinLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullable(),
  MaxLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullable(),
  Metrics: z.array(zCreateOrganizationMetricBulkItem),
})

export const zCustomerDto = z.object({
  Id: z.uuid(),
  Name: z.string(),
  DisplayName: z.string(),
})

export const zCustomLayerDto = z.object({
  Id: z.uuid(),
  Url: z.string(),
  Title: z.string().nullable(),
})

export const zEnabledConnection = z.object({
  ConnectionId: z.string().optional(),
  AssignMembershipOnLogin: z.boolean().optional(),
  ShowAsButton: z.boolean().optional(),
  IsSignupEnabled: z.boolean().optional(),
})

export const zFeatureDto = z.object({
  Id: z.uuid(),
  Name: z.string(),
  DisplayName: z.string(),
  Description: z.string().nullable(),
  ApplicationId: z.uuid(),
  ApplicationName: z.string(),
})

export const zFeatureGrantDto = z.object({
  Id: z.uuid(),
  Feature: z.string(),
  ApplicationId: z.uuid(),
  ApplicationName: z.string(),
})

export const zFireriskMetricPresetRowDto = z.object({
  MetricId: z.uuid(),
  MetricName: z.string().nullable(),
  RiskType: z.string(),
  MinLevel: z.union([
    z
      .int()
      .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
      .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
    z.string().regex(/^-?(?:0|[1-9]\d*)$/),
  ]),
  MaxLevel: z.union([
    z
      .int()
      .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
      .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
    z.string().regex(/^-?(?:0|[1-9]\d*)$/),
  ]),
  DisplayOrder: z.union([
    z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    z.string().regex(/^-?(?:0|[1-9]\d*)$/),
  ]),
})

export const zFireriskMetricPresetResultDto = z.object({
  Added: z.array(zFireriskMetricPresetRowDto),
  Skipped: z.array(zFireriskMetricPresetRowDto),
})

export const zFrontendInviteeDto = z.object({
  Email: z.string().optional(),
})

export const zFrontendInvitationDto = z.object({
  Invitee: zFrontendInviteeDto.optional(),
  Roles: z.array(z.string()).optional(),
})

export const zFrontendInvitationListDto = z.object({
  Invitations: z.array(zFrontendInvitationDto).optional(),
})

export const zIdentities = z.object({
  Provider: z.string().optional(),
  IsSocial: z.boolean().optional(),
  Connection: z.string().optional(),
  UserId: z.string().optional(),
})

export const zIFormFile = z.string()

export const zInvitee = z.object({
  Name: z.string().nullish(),
  Email: z.string().nullish(),
})

export const zInvitation = z.object({
  Id: z.string().nullish(),
  OrganizationId: z.string().nullish(),
  Invitee: zInvitee.optional(),
  Inviter: zInvitee.nullish(),
  InvitationUrl: z.string().nullish(),
  CreatedAt: z.string().nullish(),
  ExpiresAt: z.string().nullish(),
  ClientId: z.string().nullish(),
  ConnectionId: z.string().nullish(),
  AppMetadata: z.record(z.string(), z.unknown()).nullish(),
  UserMetadata: z.record(z.string(), z.unknown()).nullish(),
  Roles: z.array(z.string()).optional(),
  TicketId: z.string().nullish(),
  SendInvitationEmail: z.boolean().nullish(),
  TtlSec: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
})

export const zJsonElement = z.unknown()

export const zGeoprocessResultDto = z.object({
  BlobUrl: z.string(),
  GeoJson: zJsonElement,
})

export const zJsonNode = z.unknown()

export const zAuditLogDto = z.object({
  Id: z.uuid(),
  SchemaVersion: z.union([
    z
      .int()
      .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
      .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    z.string().regex(/^-?(?:0|[1-9]\d*)$/),
  ]),
  AuthorEmail: z.string(),
  TableName: z.string(),
  RecordId: z.string(),
  Action: z.string(),
  OldData: zJsonNode.nullable(),
  NewData: zJsonNode.nullable(),
  IpAddress: z.string().nullable(),
  Browser: z.string().nullable(),
  OrganizationId: z.string().nullable(),
  ApplicationId: z.uuid().nullable(),
  InsertedTimestamp: z.iso.datetime(),
})

export const zLayerAssignmentDto = z.object({
  LayerId: z.uuid().optional(),
  LayerCategoryId: z.uuid().optional(),
  LayerCategoryName: z.string().nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Zindex: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zLayerAssignmentFailureDto = z.object({
  LayerId: z.uuid(),
  Reason: z.string(),
})

export const zBatchAssignLayersResultDto = z.object({
  Assigned: z.array(zLayerAssignmentDto).optional(),
  Failed: z.array(zLayerAssignmentFailureDto).optional(),
})

export const zLayerCategoryLayerDto = z.object({
  LayerCategoryId: z.uuid().optional(),
  LayerId: z.uuid().optional(),
  Deleted: z.boolean().optional(),
  Zindex: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zLayerCredentialByUserDto = z.object({
  Id: z.uuid().optional(),
  AccessToken: z.string().nullish(),
  OrganizationId: z.string().nullish(),
  AuthenticationEndpoint: z.string().nullish(),
  AuthenticationType: z.string().nullish(),
  CreatedAt: z.iso.datetime().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  DecryptedPassword: z.string().nullish(),
  DecryptedUsername: z.string().nullish(),
  Deleted: z.boolean().nullish(),
})

export const zLayerCredentialDto = z.object({
  Id: z.uuid().optional(),
  AccessToken: z.string().nullish(),
  OrganizationId: z.string().nullish(),
  AuthenticationType: z.string().nullish(),
})

export const zLayerRenderer = z.object({
  Id: z.uuid().optional(),
  LayerId: z.uuid().nullish(),
  DisplayName: z.string().nullish(),
  Data: z.string().nullish(),
  Active: z.boolean().optional(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
})

export const zLayerRendererDto = z.object({
  Id: z.uuid().optional(),
  LayerId: z.uuid().nullish(),
  DisplayName: z.string().nullish(),
  Data: zJsonNode.nullish(),
  Active: z.boolean().optional(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
})

export const zLayerType = z.object({
  Id: z.uuid().optional(),
  Name: z.string().nullish(),
  DisplayName: z.string().nullish(),
  Description: z.string().nullish(),
})

export const zLayerTypeDto = z.object({
  Id: z.uuid().optional(),
  Name: z.string().nullish(),
  DisplayName: z.string().nullish(),
  Description: z.string().nullish(),
})

export const zLayerDto = z.object({
  Id: z.uuid().optional(),
  LayerTypeId: z.uuid().nullish(),
  LayerCredentialId: z.uuid().nullish(),
  ParentId: z.uuid().nullish(),
  Description: z.string().nullish(),
  Title: z.string().nullish(),
  Icon: z.string().nullish(),
  Opacity: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Active: z.boolean().optional(),
  Legend: z.string().nullish(),
  MinZoomLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MaxZoomLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Extent: zJsonNode.nullish(),
  RefreshInterval: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Private: z.boolean().optional(),
  Available: z.boolean().optional(),
  AvailableAt: z.iso.datetime().nullish(),
  Thumbnail: z.string().nullish(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
  Deleted: z.boolean().optional(),
  Url: z.string().nullish(),
  ExtraData: zJsonNode.nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Zindex: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  LayerTypeName: z.string().nullish(),
  LayerType: zLayerTypeDto.nullish(),
  LayerRenderers: z.array(zLayerRendererDto).nullish(),
})

export const zLayerCategoryDto = z.object({
  Id: z.uuid().optional(),
  DisplayName: z.string().nullish(),
  Deleted: z.boolean().optional(),
  OrganizationId: z.string().nullish(),
  IsCustom: z.boolean().optional(),
  Applications: z.array(z.string()).optional(),
  LayerList: z.array(zLayerDto).optional(),
  LayerCategoryLayer: z.array(zLayerCategoryLayerDto).optional(),
  LayerCategory: z.array(z.lazy((): any => zLayerCategoryDto)).optional(),
})

export const zMetricCategoryDto = z.object({
  Id: z.uuid().optional(),
  Name: z.string().nullish(),
  Displayname: z.string().nullish(),
  Description: z.string().nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zOrganizationMetricDto = z.object({
  Id: z.uuid().optional(),
  MetricId: z.uuid().nullish(),
  OrganizationId: z.string().nullish(),
  LayerId: z.uuid().nullish(),
  RiskType: z.string().nullish(),
  ApplicationId: z.uuid().optional(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MinLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MaxLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
})

export const zPagedResultDtoOfAuditLogDto = z.object({
  Items: z.array(zAuditLogDto).optional(),
  Total: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zPagedResultDtoOfCatalogLayerDto = z.object({
  Items: z.array(zCatalogLayerDto).optional(),
  Total: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zPagedResultDtoOfCatalogMetricDto = z.object({
  Items: z.array(zCatalogMetricDto).optional(),
  Total: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
})

export const zPairingDto = z.object({
  Id: z.uuid().optional(),
  Name: z.string().nullish(),
  DisplayName: z.string().nullish(),
  Description: z.string().nullish(),
})

export const zMetricPairingDto = z.object({
  PairingId: z.uuid().optional(),
  Pairing: zPairingDto.optional(),
})

export const zMetricDto = z.object({
  Id: z.uuid().optional(),
  MetricCategoryId: z.uuid().nullish(),
  Metriccategory: zMetricCategoryDto.nullish(),
  Name: z.string().optional(),
  Displayname: z.string().nullish(),
  Description: z.string().nullish(),
  Icon: z.string().nullish(),
  Active: z.boolean().nullish(),
  Uom: z.string().nullish(),
  Classbreaks: z.string().nullish(),
  Interval: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Precision: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Datasource: z.string().optional(),
  Color: z.string().optional(),
  Style: z.string().optional(),
  MinLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MaxLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MetricPairing: z.array(zMetricPairingDto).nullish(),
  OrganizationMetric: z.array(zOrganizationMetricDto).nullish(),
})

export const zProblemDetails = z.object({
  type: z.string().nullish(),
  title: z.string().nullish(),
  status: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  detail: z.string().nullish(),
  instance: z.string().nullish(),
})

export const zProfile = z.object({
  UserMetadata: z.record(z.string(), z.string()).nullish(),
  AppMetadata: z.record(z.string(), z.unknown()).nullish(),
  UserId: z.string().nullish(),
  GivenName: z.string().nullish(),
  UpdatedAt: z.string().nullish(),
  Picture: z.string().nullish(),
  EmailVerified: z.boolean().nullish(),
  IdpTenantDomain: z.string().nullish(),
  Email: z.string().nullish(),
  Name: z.string().nullish(),
  CreatedAt: z.string().nullish(),
  Identities: z.array(zIdentities).nullish(),
  Id: z.string().nullish(),
  Nickname: z.string().nullish(),
  FamilyName: z.string().nullish(),
  LastLogin: z.string().nullish(),
  LastIp: z.string().nullish(),
  LoginsCount: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
})

export const zRenameCustomLayerRequest = z.object({
  Title: z.string(),
})

export const zRolesDto = z.object({
  Roles: z.array(z.string()).optional(),
})

export const zToggleFlagRequest = z.object({
  ProductName: z.string(),
  Enabled: z.boolean(),
})

export const zTranslation = z.object({
  Id: z.uuid().optional(),
  ApplicationId: z.uuid().nullish(),
  Key: z.string().nullish(),
  Value: z.string().nullish(),
  Language: z.string().nullish(),
  OrganizationId: z.string().nullish(),
  Deleted: z.boolean().optional(),
})

export const zUpdateOrganizationConfigurationDto = z.object({
  Aggregation: z.string().nullable(),
  Basemap: z.string().nullable(),
  Timezone: z.string().nullish(),
  DateFormat: z.string().nullish(),
  TimeFormat: z.string().nullish(),
  HelpdeskUrl: z.string().nullish(),
  InitialExtent: z.string().nullish(),
  Extra: z.string().nullish(),
})

export const zUserConfigurationDto = z.object({
  UserId: z.string().optional(),
  Theme: z.string().nullish(),
  Language: z.string().nullish(),
  Uom: z.string().nullish(),
  AdvancedUom: z.string().nullish(),
})

export const zApplication = z.object({
  Id: z.uuid().optional(),
  DisplayName: z.string().nullish(),
  Description: z.string().nullish(),
  Deleted: z.boolean().optional(),
  Slug: z.string().optional(),
  Title: z.string().optional(),
  Tag: z.string().nullish(),
  Link: z.string().nullish(),
  Image: z.string().optional(),
  Permission: z.string().nullish(),
  ButtonOnly: z.string().nullish(),
  SortOrder: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Enabled: z.boolean().optional(),
  ApplicationConfigurations: z.array(z.lazy((): any => zApplicationConfiguration)).optional(),
  LayerCategories: z.array(z.lazy((): any => zLayerCategory)).optional(),
})

export const zApplicationConfiguration = z.object({
  ApplicationConfigurationId: z.uuid().optional(),
  ApplicationId: z.uuid().nullish(),
  OrganizationId: z.string().nullish(),
  UserId: z.string().nullish(),
  InitialExtent: z.string().nullish(),
  Aggregation: z.string().nullish(),
  Basemap: z.string().nullish(),
  Timezone: z.string().nullish(),
  DateFormat: z.string().nullish(),
  TimeFormat: z.string().nullish(),
  HelpdeskUrl: z.string().nullish(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
  Deleted: z.boolean().optional(),
  Extra: z.string().nullish(),
  Application: zApplication.nullish(),
})

export const zLayer = z.object({
  Id: z.uuid().optional(),
  LayerTypeId: z.uuid().nullish(),
  LayerCredentialId: z.uuid().nullish(),
  ParentId: z.uuid().nullish(),
  Description: z.string().nullish(),
  Title: z.string().nullish(),
  Icon: z.string().nullish(),
  Opacity: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Active: z.boolean().optional(),
  Legend: z.string().nullish(),
  MinZoomLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  MaxZoomLevel: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Extent: z.string().nullish(),
  RefreshInterval: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .nullish(),
  Private: z.boolean().optional(),
  Available: z.boolean().optional(),
  AvailableAt: z.iso.datetime().nullish(),
  Thumbnail: z.string().nullish(),
  CreatedAt: z.iso.datetime().nullish(),
  CreatedBy: z.string().nullish(),
  UpdatedAt: z.iso.datetime().nullish(),
  UpdatedBy: z.string().nullish(),
  Deleted: z.boolean().optional(),
  Url: z.string().nullish(),
  ExtraData: z.string().nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  LayerType: zLayerType.nullish(),
  LayerCategoryLayers: z.array(z.lazy((): any => zLayerCategoryLayer)).optional(),
  LayerRenderers: z.array(zLayerRenderer).optional(),
})

export const zLayerCategory = z.object({
  Id: z.uuid().optional(),
  DisplayName: z.string().nullish(),
  Deleted: z.boolean().optional(),
  ParentId: z.uuid().nullish(),
  OrganizationId: z.string().nullish(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  IsCustom: z.boolean().optional(),
  LayerCategoryLayers: z.array(z.lazy((): any => zLayerCategoryLayer)).optional(),
})

export const zLayerCategoryLayer = z.object({
  LayerCategoryId: z.uuid().optional(),
  LayerId: z.uuid().optional(),
  Deleted: z.boolean().optional(),
  DisplayOrder: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Zindex: z
    .union([
      z
        .int()
        .min(-32768, { error: 'Invalid value: Expected int16 to be >= -32768' })
        .max(32767, { error: 'Invalid value: Expected int16 to be <= 32767' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  LayerCategory: zLayerCategory.optional(),
  Layer: zLayer.optional(),
})

export const zGetApiV1TranslationQuery = z.object({
  applicationId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1TranslationResponse = z.record(z.string(), z.record(z.string(), z.unknown()))

export const zPostApiV1TranslationBody = zTranslation

export const zGetApiV1TbAuthGenerateJwtQuery = z.object({
  applicationId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1TbAuthGenerateJwtResponse = zAnalyticsToken

/**
 * OK
 */
export const zGetApiV1MetricCategoryResponse = z.array(zMetricCategoryDto)

export const zGetApiV1MetricQuery = z.object({
  applicationId: z.uuid().optional(),
  riskType: z.string().optional(),
})

/**
 * OK
 */
export const zGetApiV1MetricResponse = z.array(zMetricDto)

export const zGetApiV1MetricByMetricIdPath = z.object({
  metricId: z.uuid(),
})

export const zGetApiV1MetricByMetricIdQuery = z.object({
  applicationId: z.uuid().optional(),
})

/**
 * OK
 */
export const zGetApiV1MetricByMetricIdResponse = zMetricDto

export const zGetApiV1MetricAssignmentsQuery = z.object({
  OrganizationId: z.string().optional(),
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Search: z.string().optional(),
  ApplicationId: z.uuid().optional(),
  Datasource: z.string().optional(),
  SortBy: z.string().optional(),
  SortDescending: z.boolean().optional(),
})

/**
 * OK
 */
export const zGetApiV1MetricAssignmentsResponse = zPagedResultDtoOfCatalogMetricDto

export const zGetApiV1MetricOrganizationsByOrganizationIdAssignedMetricIdsPath = z.object({
  organizationId: z.string(),
})

export const zGetApiV1MetricOrganizationsByOrganizationIdAssignedMetricIdsQuery = z.object({
  applicationId: z.uuid().optional(),
  riskType: z.string().optional(),
})

/**
 * OK
 */
export const zGetApiV1MetricOrganizationsByOrganizationIdAssignedMetricIdsResponse = z.array(
  z.uuid(),
)

export const zPostApiV1MetricOrganizationsByOrganizationIdBulkBody =
  zCreateOrganizationMetricsBulkRequest

export const zPostApiV1MetricOrganizationsByOrganizationIdBulkPath = z.object({
  organizationId: z.string(),
})

/**
 * Created
 */
export const zPostApiV1MetricOrganizationsByOrganizationIdBulkResponse =
  z.array(zOrganizationMetricDto)

export const zPostApiV1MetricOrganizationsByOrganizationIdFireriskPresetBody =
  zApplyFireriskMetricPresetRequest

export const zPostApiV1MetricOrganizationsByOrganizationIdFireriskPresetPath = z.object({
  organizationId: z.string(),
})

/**
 * OK
 */
export const zPostApiV1MetricOrganizationsByOrganizationIdFireriskPresetResponse =
  zFireriskMetricPresetResultDto

export const zDeleteApiV1MetricByMetricIdOrganizationsByOrganizationIdPath = z.object({
  metricId: z.uuid(),
  organizationId: z.string(),
})

export const zDeleteApiV1MetricByMetricIdOrganizationsByOrganizationIdQuery = z.object({
  applicationId: z.uuid().optional(),
  riskType: z.string().optional(),
})

/**
 * No Content
 */
export const zDeleteApiV1MetricByMetricIdOrganizationsByOrganizationIdResponse = z.void()

/**
 * OK
 */
export const zGetApiV1PairingResponse = z.array(zPairingDto)

export const zGetApiV1PairingByPairingIdPath = z.object({
  pairingId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1PairingByPairingIdResponse = zPairingDto

export const zPostApiV1CustomLayerBody = zCreateCustomLayerRequest

export const zPostApiV1CustomLayerQuery = z.object({
  applicationId: z.uuid(),
})

/**
 * Created
 */
export const zPostApiV1CustomLayerResponse = zCustomLayerDto

export const zDeleteApiV1CustomLayerByIdPath = z.object({
  id: z.uuid(),
})

/**
 * No Content
 */
export const zDeleteApiV1CustomLayerByIdResponse = z.void()

export const zPatchApiV1CustomLayerByIdBody = zRenameCustomLayerRequest

export const zPatchApiV1CustomLayerByIdPath = z.object({
  id: z.uuid(),
})

/**
 * No Content
 */
export const zPatchApiV1CustomLayerByIdResponse = z.void()

export const zGetApiV1LayerQuery = z.object({
  applicationId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1LayerResponse = z.array(zLayerCategoryDto)

export const zGetApiV1LayerByLayerIdPath = z.object({
  layerId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1LayerByLayerIdResponse = zLayerDto

export const zGetApiV1LayerCategoriesQuery = z.object({
  organizationId: z.string().optional(),
})

/**
 * OK
 */
export const zGetApiV1LayerCategoriesResponse = z.array(zLayerCategoryDto)

export const zGetApiV1LayerAssignmentsQuery = z.object({
  OrganizationId: z.string().optional(),
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Search: z.string().optional(),
  ApplicationId: z.uuid().optional(),
  Datasource: z.string().optional(),
  SortBy: z.string().optional(),
  SortDescending: z.boolean().optional(),
})

/**
 * OK
 */
export const zGetApiV1LayerAssignmentsResponse = zPagedResultDtoOfCatalogLayerDto

/**
 * OK
 */
export const zGetApiV1LayerCredentialResponse = z.array(zLayerCredentialDto)

export const zGetApiV1LayerCredentialByIdPath = z.object({
  id: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1LayerCredentialByIdResponse = zLayerCredentialDto

export const zGetApiV1LayerCredentialUserByUserPath = z.object({
  user: z.string(),
})

/**
 * OK
 */
export const zGetApiV1LayerCredentialUserByUserResponse = z.array(zLayerCredentialByUserDto)

/**
 * OK
 */
export const zGetApiV1LayerCredentialUserResponse = z.array(zLayerCredentialByUserDto)

/**
 * OK
 */
export const zGetApiV1LayerTypeResponse = z.array(zLayerTypeDto)

export const zDeleteApiV1GeoProcessShapefileToGeojsonQuery = z.object({
  blobUrl: z.string(),
})

/**
 * No Content
 */
export const zDeleteApiV1GeoProcessShapefileToGeojsonResponse = z.void()

export const zPostApiV1GeoProcessShapefileToGeojsonBody = z.object({
  file: zIFormFile.optional(),
})

/**
 * OK
 */
export const zPostApiV1GeoProcessShapefileToGeojsonResponse = z.array(zGeoprocessResultDto)

export const zGetApiV1AdminFeatureflagQuery = z.object({
  productName: z.string().optional(),
})

export const zPatchApiV1AdminFeatureflagByFlagNameBody = zToggleFlagRequest

export const zPatchApiV1AdminFeatureflagByFlagNamePath = z.object({
  flagName: z.string(),
})

/**
 * No Content
 */
export const zPatchApiV1AdminFeatureflagByFlagNameResponse = z.void()

export const zGetApiV1FeatureFlagHeaders = z.object({
  'x-api-key': z.string().optional(),
})

export const zGetApiV1FeatureFlagQuery = z.object({
  productName: z.string().optional(),
  environment: z.string().optional(),
  userId: z.string().optional(),
  organizationId: z.string().optional(),
})

/**
 * OK
 */
export const zGetApiV1FeaturesResponse = z.array(zFeatureDto)

export const zGetApiV1CustomerByCustomerIdFeaturesPath = z.object({
  customerId: z.uuid(),
})

export const zGetApiV1CustomerByCustomerIdFeaturesQuery = z.object({
  applicationId: z.uuid().optional(),
})

/**
 * OK
 */
export const zGetApiV1CustomerByCustomerIdFeaturesResponse = z.array(zFeatureDto)

export const zDeleteApiV1CustomerByCustomerIdFeaturesByFeatureIdPath = z.object({
  customerId: z.uuid(),
  featureId: z.uuid(),
})

/**
 * No Content
 */
export const zDeleteApiV1CustomerByCustomerIdFeaturesByFeatureIdResponse = z.void()

export const zPostApiV1CustomerByCustomerIdFeaturesByFeatureIdPath = z.object({
  customerId: z.uuid(),
  featureId: z.uuid(),
})

/**
 * No Content
 */
export const zPostApiV1CustomerByCustomerIdFeaturesByFeatureIdResponse = z.void()

/**
 * OK
 */
export const zGetApiV1CustomerResponse = z.array(zCustomerDto)

export const zGetApiV1CustomerGrantsMeQuery = z.object({
  applicationId: z.uuid().optional(),
})

/**
 * OK
 */
export const zGetApiV1CustomerGrantsMeResponse = z.array(zFeatureGrantDto)

export const zGetApiV1ApplicationConfigurationByApplicationIdPath = z.object({
  applicationId: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1ApplicationConfigurationByApplicationIdResponse = z.array(
  zApplicationConfigurationDto,
)

export const zGetApiV1OrganizationConfigurationQuery = z.object({
  applicationId: z.uuid().optional(),
})

/**
 * OK
 */
export const zGetApiV1OrganizationConfigurationResponse = z.array(zApplicationConfigurationDto)

/**
 * The permitted fields to update
 */
export const zPutApiV1OrganizationConfigurationByConfigurationIdBody =
  zUpdateOrganizationConfigurationDto

export const zPutApiV1OrganizationConfigurationByConfigurationIdPath = z.object({
  configurationId: z.uuid(),
})

/**
 * No Content
 */
export const zPutApiV1OrganizationConfigurationByConfigurationIdResponse = z.void()

/**
 * OK
 */
export const zGetApiV1UserConfigurationResponse = z.array(zUserConfigurationDto)

export const zPostApiV1ClientsByClientIdLayersBody = zAssignLayerRequest

export const zPostApiV1ClientsByClientIdLayersPath = z.object({
  clientId: z.string(),
})

/**
 * OK
 */
export const zPostApiV1ClientsByClientIdLayersResponse = zBatchAssignLayersResultDto

export const zDeleteApiV1ClientsByClientIdLayersByLayerIdPath = z.object({
  clientId: z.string(),
  layerId: z.uuid(),
})

export const zDeleteApiV1ClientsByClientIdLayersByLayerIdQuery = z.object({
  layerCategoryId: z.uuid().optional(),
})

/**
 * No Content
 */
export const zDeleteApiV1ClientsByClientIdLayersByLayerIdResponse = z.void()

/**
 * OK
 */
export const zGetApiV1ClientResourceResponse = z.array(zClientResourceDto)

export const zGetApiV1ClientResourceByIdPath = z.object({
  id: z.uuid(),
})

/**
 * OK
 */
export const zGetApiV1ClientResourceByIdResponse = zClientResourceDto

export const zGetApiV1CatalogMetricsQuery = z.object({
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Search: z.string().optional(),
  ApplicationId: z.uuid().optional(),
  Datasource: z.string().optional(),
  SortBy: z.string().optional(),
  SortDescending: z.boolean().optional(),
})

/**
 * OK
 */
export const zGetApiV1CatalogMetricsResponse = zPagedResultDtoOfCatalogMetricDto

export const zGetApiV1CatalogLayersQuery = z.object({
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Search: z.string().optional(),
  ApplicationId: z.uuid().optional(),
  Datasource: z.string().optional(),
  SortBy: z.string().optional(),
  SortDescending: z.boolean().optional(),
})

/**
 * OK
 */
export const zGetApiV1CatalogLayersResponse = zPagedResultDtoOfCatalogLayerDto

/**
 * OK
 */
export const zGetApiV1CatalogApplicationsResponse = z.array(zCatalogApplicationDto)

export const zGetApiV1SettingsByApplicationIdPath = z.object({
  applicationId: z.uuid(),
})

/**
 * A dictionary (JSON object) containing the configuration key-value pairs to be saved. These values will overwrite existing keys or add new ones to the user's configuration set. The values can be any JSON-compatible type (string, number, boolean, object, array, null). Null values are treated as updates, not as deletions.
 */
export const zPutApiV1SettingsByApplicationIdBody = z.record(z.string(), z.unknown())

export const zPutApiV1SettingsByApplicationIdPath = z.object({
  applicationId: z.uuid(),
})

export const zPostApiV1Auth0ConnectionBody = z.object({
  ConnectionName: z.string().optional(),
  SignInUrl: z.string().optional(),
  DiscoveryUrl: z.string().optional(),
  Domain: z.string().optional(),
  ClientId: z.string().optional(),
  ClientSecret: z.string().optional(),
  Certificate: zIFormFile.optional(),
  Strategy: z.string().optional(),
})

export const zGetApiV1Auth0InviteQuery = z.object({
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  Search: z.string().optional(),
  SortBy: z.string().optional(),
  SortDesc: z.string().optional(),
  IsDescending: z.boolean().optional(),
})

export const zPostApiV1Auth0InviteBody = zFrontendInvitationListDto

export const zPostApiV1Auth0InviteQuery = z.object({
  organizationId: z.string().optional(),
})

export const zPutApiV1Auth0InviteBody = zInvitation

export const zGetApiV1Auth0OrganizationQuery = z.object({
  page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
  itemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(30),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.string().optional(),
  byRisk: z.boolean().optional().default(false),
})

export const zPatchApiV1Auth0OrganizationBody = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  DisplayName: z.string().optional(),
  'branding.logo': zIFormFile.optional(),
  'branding.LogoUrl': z.string().optional(),
  'branding.colors.PageBackground': z.string().optional(),
  'branding.colors.primary': z.string().optional(),
  metadata: z.record(z.string(), z.string()).optional(),
  EnabledConnections: z.array(zEnabledConnection).optional(),
})

export const zPostApiV1Auth0OrganizationBody = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  DisplayName: z.string().optional(),
  'branding.logo': zIFormFile.optional(),
  'branding.LogoUrl': z.string().optional(),
  'branding.colors.PageBackground': z.string().optional(),
  'branding.colors.primary': z.string().optional(),
  metadata: z.record(z.string(), z.string()).optional(),
  EnabledConnections: z.array(zEnabledConnection).optional(),
})

export const zGetApiV1Auth0OrganizationByOrgIdPath = z.object({
  orgId: z.string(),
})

export const zDeleteApiV1Auth0OrganizationByIdPath = z.object({
  id: z.string(),
})

export const zGetApiV1Auth0UserQuery = z.object({
  page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
  itemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(30),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.string().optional(),
  organizationId: z.string().optional(),
  showInternal: z.boolean().optional().default(true),
})

export const zGetApiV1Auth0UserByIdPath = z.object({
  id: z.string(),
})

export const zGetApiV1Auth0UserByIdQuery = z.object({
  organizationId: z.string().optional(),
})

export const zDeleteApiV1Auth0UserByUserIdMemberPath = z.object({
  userId: z.string(),
})

export const zDeleteApiV1Auth0UserByUserIdMemberQuery = z.object({
  organizationId: z.string().optional(),
})

export const zGetApiV1Auth0UserByUserIdLogsPath = z.object({
  userId: z.string(),
})

export const zGetApiV1Auth0UserByUserIdLogsQuery = z.object({
  page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
  perPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(50),
})

export const zGetApiV1Auth0UserByUserIdApplicationsPath = z.object({
  userId: z.string(),
})

export const zDeleteApiV1Auth0UserByUserIdRolesBody = zRolesDto

export const zDeleteApiV1Auth0UserByUserIdRolesPath = z.object({
  userId: z.string(),
})

export const zDeleteApiV1Auth0UserByUserIdRolesQuery = z.object({
  organizationId: z.string().optional(),
})

export const zGetApiV1Auth0UserByUserIdRolesPath = z.object({
  userId: z.string(),
})

export const zGetApiV1Auth0UserByUserIdRolesQuery = z.object({
  organizationId: z.string().optional(),
})

export const zPostApiV1Auth0UserByUserIdRolesBody = zRolesDto

export const zPostApiV1Auth0UserByUserIdRolesPath = z.object({
  userId: z.string(),
})

export const zPostApiV1Auth0UserByUserIdRolesQuery = z.object({
  organizationId: z.string().optional(),
})

export const zGetApiV1Auth0UserMeOrganizationsQuery = z.object({
  page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(0),
  itemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional()
    .default(50),
})

export const zPatchApiV1Auth0UserMeBody = zProfile

export const zGetApiV1AdminAuditLogQuery = z.object({
  Page: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  ItemsPerPage: z
    .union([
      z
        .int()
        .min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' })
        .max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
      z.string().regex(/^-?(?:0|[1-9]\d*)$/),
    ])
    .optional(),
  TableName: z.string().optional(),
  RecordId: z.string().optional(),
  Action: zAuditAction.optional(),
  AuthorEmail: z.string().optional(),
  OrganizationId: z.string().optional(),
  ApplicationId: z.uuid().optional(),
  From: z.iso.datetime().optional(),
  To: z.iso.datetime().optional(),
})

/**
 * OK
 */
export const zGetApiV1AdminAuditLogResponse = zPagedResultDtoOfAuditLogDto

export const zGetApiV1AssetsByIdPath = z.object({
  id: z.uuid(),
})

export const zPostApiV1AssetsQuery = z.object({
  expiredAt: z.iso.datetime(),
  organizationId: z.string(),
})

/**
 * OK
 */
export const zGetApiV1ApplicationResponse = z.array(zApplicationDto)

/**
 * The configuration to be created
 */
export const zPostApiV1ApplicationConfigurationBody = zApplicationConfiguration

/**
 * The configuration to be created
 */
export const zPutApiV1ApplicationConfigurationByConfigurationIdBody = zApplicationConfiguration

export const zPutApiV1ApplicationConfigurationByConfigurationIdPath = z.object({
  configurationId: z.uuid(),
})

/**
 * No Content
 */
export const zPutApiV1ApplicationConfigurationByConfigurationIdResponse = z.void()
